// extracted by mini-css-extract-plugin
module.exports = {"tooltipComponent":"tooltip-module--tooltipComponent--2hmoD","visible":"tooltip-module--visible--2HFKt"};